export const getStepIndicatorStyle = (_, { palette = {} }) => ({
  stepIndicator: {
    display: 'flex',
    border: 'none',
    flexShrink: 0,
    color: palette.neutralSecondary,
  },
  currentStep: {
    fontWeight: 'bold',
    color: palette.accent,
  },
  stepIndicatorIndex: {
    border: '1px solid',
    borderRadius: '50%',
    width: 20,
    height: 20,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 8,
  },
  stepIndicatorTitle: {
    marginRight: 32,
  },
});

export const getStepProgressBarStyle = () => ({
  stepProgressBar: {
    display: 'flex',
  },
});
